import { render, staticRenderFns } from "./InfoHome.vue?vue&type=template&id=06111179&scoped=true"
import script from "./InfoHome.vue?vue&type=script&lang=js"
export * from "./InfoHome.vue?vue&type=script&lang=js"
import style0 from "./InfoHome.vue?vue&type=style&index=0&id=06111179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06111179",
  null
  
)

export default component.exports